import Vue from 'vue'
import Vuex from 'vuex'//状態管理ライブラリVuexの読み込み

Vue.use(Vuex)//VueにVuexを使用することを宣言

////////////////////////////////////////////////////////////////////////////////////////////////////
//
// 画面が変わっても・コンポーネント(部品＝画面一部）が変わっても、ログイン状態を共通で使えるようにするため
//
////////////////////////////////////////////////////////////////////////////////////////////////////

//Vuexストアの作成
const store = new Vuex.Store({

    //状態管理用のデータ
    state: {
        isLogin : false,//ログイン状態を管理するフラグ
        userId : ''//ログインユーザーのID
    },

    //状態管理用のメソッド（storeの中身を書き込める）
    mutations: {
        auth(state, user) {
            state.isLogin = true;//storeのログイン状態をtrueに設定
            state.userId = user;//storeのユーザーIDを設定
        }
    },
    //状態管理用のメソッド（非同期処理)
    //actionsは、mutationsを呼び出すためのメソッド（非同期処理を行うためのもの）
    actions: {
        fetch(context, user) {
            //commitを使ってmutationsのauthメソッドを呼び出す→ユーザー情報をstoreに保存する
            context.commit('auth', user);
        }
    },
    //状態管理用のモジュール（今回は未使用）
    modules: {},
})

export default store